// client-fnbpos.ts — cấu hình OpenAPI singleton RIÊNG cho client sinh từ module fnbpos (F&B/POS
// backend, xem scripts/rewrite-fnbpos-openapi.mjs + generate-api-fnbpos). Client này TÁCH khỏi
// './client' vì openapi-typescript-codegen sinh 1 object OpenAPI ĐỘC LẬP mỗi output dir — nhưng dùng
// CHUNG base URL + logic token (import từ client.ts, không lặp lại) vì cả 2 đều gọi cùng 1 bo-gateway.
//
// tenant_id F&B = organization_slug (ánh xạ 1:1) — mọi hàm generated đều nhận `organizer` làm tham số
// đầu (path param), KHÔNG có field tenant_id/staff_id/roles trong body (đã lọc lúc rewrite openapi vì
// luôn bị gateway ghi đè, xem internal/handlers/fnbpos.Proxy phía bo-gateway).
import { OpenAPI as FnbposOpenAPI } from './generated-fnbpos';
import { getAuthToken, getBaseUrl } from './client';

FnbposOpenAPI.BASE = getBaseUrl();
FnbposOpenAPI.TOKEN = async (): Promise<string> => getAuthToken();
FnbposOpenAPI.WITH_CREDENTIALS = false;
FnbposOpenAPI.CREDENTIALS = 'include';
FnbposOpenAPI.HEADERS = async (): Promise<Record<string, string>> => {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  const token = getAuthToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

export * from './generated-fnbpos';
export { FnbposOpenAPI };
